import { MoneyConnectClientAPI } from "./axios-service-creator";

export const AnnouncementAPI = {
  fetchAnnounceList: () => MoneyConnectClientAPI.get("/subscription/announcement"),
};
